import { NgModule } from '@angular/core';
import { LikesComponent } from './likes.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '../app-text';
import { FiCommentLikeButtonsModule } from '../fi-comments/fi-comment-like-buttons/fi-comment-like-buttons.module';
import { MatCardModule } from '@angular/material/card';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        FiAppTextSharedModule,
        FiCommentLikeButtonsModule,
        MatCardModule,
    ],
    declarations: [LikesComponent],
    exports: [LikesComponent],
})
export class FiLikesModule {}
